import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import NextLink from "next/link";
import {CmLinkableWithChildren} from "../types/navigation";
import {commonStyles} from "../styles";
import {CmLinkableType} from "../../../../types";

interface TopNavigationItemsProps {
    items: Array<CmLinkableType>;
    onClose: () => void;
    isItemActive: (item: CmLinkableType, isEasyLangMode?: boolean) => boolean;
    isEasyLangMode?: boolean;
}

const TopNavigationItems: React.FC<TopNavigationItemsProps> = ({
                                                                   items,
                                                                   onClose,
                                                                   isItemActive,
                                                                   isEasyLangMode
                                                               }) => {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <Box sx={{mt: 4}}>
            <List disablePadding>
                {items.map((item, index) => {
                    const componentProp = NextLink;
                    const hrefProp = item.selfUrl || "#";

                    return (
                        <ListItemButton
                            key={index}
                            component={componentProp}
                            href={hrefProp}
                            onClick={onClose}
                            sx={{
                                margin: '16px auto',
                                height: 'auto',
                                minHeight: 'unset',
                                padding: "0 12px !important",
                                "&:hover": commonStyles.hoverStyles,
                                ...commonStyles.activeStyles(isItemActive(item, isEasyLangMode), false, true)
                            }}
                        >
                            <ListItemText
                                primary={((item as CmLinkableWithChildren)?.teaserTitle ||
                                    item.title)}
                                slotProps={{
                                    primary: {
                                        sx: {
                                            fontSize: '12px !important',
                                            fontFamily: 'HelveticaNeueLTStd-Md, Helvetica, Arial, sans-serif',
                                            my: 0
                                        },
                                        style: {fontSize: '12px'}
                                    }
                                }}
                            />
                        </ListItemButton>
                    );
                })}
            </List>
        </Box>
    );
};

export default TopNavigationItems;
